import { render } from "./ListaCarga.vue?vue&type=template&id=7cd8e0e4&scoped=true"
import script from "./ListaCarga.vue?vue&type=script&lang=js"
export * from "./ListaCarga.vue?vue&type=script&lang=js"

import "./ListaCarga.vue?vue&type=style&index=0&id=7cd8e0e4&scoped=true&lang=css"

import exportComponent from "/var/www/html/genesis-git/vue-genesis/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cd8e0e4"]])

export default __exports__